const SubscriptionLabsSkeleton = () => {
  return (
    <section className="w-full mx-auto space-y-4">
      {/* Grid of Module Cards Skeleton */}
      <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4">
        {[...Array(8)].map((_, index) => (
          <LabCardSkeleton key={index} />
        ))}
      </div>
    </section>
  )
}

const LabCardSkeleton = () => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden animate-pulse p-4">
      {/* Image skeleton */}
      <div className="w-full aspect-[332/174] bg-gray-300 rounded-md"></div>

      {/* Content skeleton */}
      <div className="space-y-4 mt-3">
        {/* Title skeleton */}
        <div className="space-y-2">
          <div className="h-6 bg-gray-300 rounded w-3/4"></div>
        </div>

        {/* Stats section skeleton */}
        <div className="border border-gray-200 rounded-lg">
          <div className="grid grid-cols-2 gap-4">
            {/* Total Duration */}
            <div className="space-y-2 p-2">
              <div className="h-2 bg-gray-200 rounded w-20"></div>
              <div className="h-2 bg-gray-300 rounded w-16"></div>
            </div>

            {/* Lab Count */}
            <div className="space-y-2 p-2">
              <div className="h-2.5 bg-gray-200 rounded w-16"></div>
              <div className="h-2.5 bg-gray-300 rounded w-14"></div>
            </div>
          </div>
        </div>

        {/* Buttons skeleton */}
        <div className="flex gap-4">
          <div className="flex-1 h-8 bg-gray-200 rounded-lg"></div>
          <div className="flex-1 h-8 bg-gray-300 rounded-lg"></div>
        </div>
      </div>
    </div>
  )
}

export default SubscriptionLabsSkeleton
